import { extend } from "vee-validate";
import moment from "moment";

// Turkish Republic Identification Validate Start
extend("turkish_identity_number", {
  validate: (value) => {
    let sum, identityNumber;
    identityNumber = value;
    sum =
      Number(identityNumber.substring(0, 1)) +
      Number(identityNumber.substring(1, 2)) +
      Number(identityNumber.substring(2, 3)) +
      Number(identityNumber.substring(3, 4)) +
      Number(identityNumber.substring(4, 5)) +
      Number(identityNumber.substring(5, 6)) +
      Number(identityNumber.substring(6, 7)) +
      Number(identityNumber.substring(7, 8)) +
      Number(identityNumber.substring(8, 9)) +
      Number(identityNumber.substring(9, 10));
    let strSum = String(sum);
    let lastValue = strSum.substring(strSum.length, strSum.length - 1);

    return lastValue === identityNumber.substring(10, 11);
  },
  message: "Geçerli bir T.C. kimlik numarası giriniz.",
});
// Turkish Republic Identification Validate End

// Validate Between Two Dates Start
extend("custom_date_between", {
  validate(value, { minDate, maxDate, dateFormat }) {
    const min = moment(minDate, dateFormat).toDate();
    const max = moment(maxDate, dateFormat).toDate();
    const date = moment(value, dateFormat).toDate();
    return date >= min && date <= max;
  },
  params: ["minDate", "maxDate", "dateFormat"],
  message: "Tarih, {minDate} ve {maxDate} arasında olmalıdır",
});
// Validate Between Two Dates End

// Validate Is Birthdate In Range Start
extend("is_birthdate_in_range", {
  // birthdate, minMonths, maxMonths, trainDate
  validate(value, { minMonths, maxMonths, trips }) {
    let isValid = true;

    trips.selectedGidisTrip.trains.forEach((train) => {
      const trainDate = moment(train.trainDate);
      const birthDate = moment(value, "DD.MM.YYYY");

      const trainTotalMonths = trainDate.year() * 12 + trainDate.month();
      const birthTotalMonths = birthDate.year() * 12 + birthDate.month();

      const minTotalMonths = trainTotalMonths - maxMonths;
      const maxTotalMonths = trainTotalMonths - minMonths;

      isValid = (maxMonths === 0 || birthTotalMonths >= minTotalMonths) && (minMonths === 0 || birthTotalMonths <= maxTotalMonths);
      if (!isValid) return false;
    });

    if (isValid && trips.selectedDonusTrip !== undefined) {
      trips.selectedDonusTrip.trains.forEach((train) => {
        const trainDate = moment(train.trainDate);
        const birthDate = moment(value, "DD.MM.YYYY");

        const trainTotalMonths = trainDate.year() * 12 + trainDate.month();
        const birthTotalMonths = birthDate.year() * 12 + birthDate.month();

        const minTotalMonths = trainTotalMonths - maxMonths;
        const maxTotalMonths = trainTotalMonths - minMonths;

        isValid = (maxMonths === 0 || birthTotalMonths >= minTotalMonths) && (minMonths === 0 || birthTotalMonths <= maxTotalMonths);

        if (!isValid) return false;
      });
    }

    return isValid;
  },
  params: ["minMonths", "maxMonths", "trips"],
  message: "Doğum tarihi seçilen tarife yaşına uymuyor.",
});
// Validate Is Birthdate In Range End

const convertStringToNumber = (val) => {
  if (typeof val === "number" || !val) return val;
  return Number(val.replaceAll(".", "").replaceAll(",", "."));
};

// Currency Input Min Currency Start
extend("custom_min_currency", {
  validate(value, { minCurrency }) {
    let convertedValue = convertStringToNumber(value);
    let convertedMinCurrency = convertStringToNumber(minCurrency);
    return convertedValue > convertedMinCurrency;
  },
  params: ["minCurrency"],
  message: "Fiyat, en az {minCurrency} olmalıdır",
});
// Currency Input Min Currency End

// Currency Input Min and Equal Currency Start
extend("custom_min_and_equal_currency", {
  validate(value, { minCurrency }) {
    let convertedValue = convertStringToNumber(value);
    let convertedMinCurrency = convertStringToNumber(minCurrency);
    return convertedValue >= convertedMinCurrency;
  },
  params: ["minCurrency"],
  message: "Fiyat, en az {minCurrency} veya {minCurrency} eşit olmalıdır",
});
// Currency Input Min and Equal  Currency End

// Currency Input Max Currency Start
extend("custom_max_currency", {
  validate(value, { maxCurrency }) {
    let convertedValue = convertStringToNumber(value);
    let convertedMaxCurrency = convertStringToNumber(maxCurrency);
    return convertedValue < convertedMaxCurrency;
  },
  params: ["maxCurrency"],
  message: "Fiyat, en fazla {maxCurrency} olmalıdır",
});
// Currency Input Max Currency End

// Currency Input Max and Equal Currency Start
extend("custom_max_and_equal_currency", {
  validate(value, { maxCurrency }) {
    let convertedValue = convertStringToNumber(value);
    let convertedMaxCurrency = convertStringToNumber(maxCurrency);
    return convertedValue <= convertedMaxCurrency;
  },
  params: ["maxCurrency"],
  message: "Fiyat, en fazla {maxCurrency} veya {maxCurrency} eşit olmalıdır",
});
// Currency Input Max and Equal Currency End
